import * as React from 'react'

import image from '../../assets/velkommen.png'
import { containerStyles } from '../../styles/ContainerStyles'

export const Banner : React.FC = () => {
    const styles = containerStyles()
    const [offset, setOffset] = React.useState(0)

    React.useEffect(() => {
        function handleScroll() {
            setOffset(window.pageYOffset)
        }

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])
    return (
        <div
            className={styles.mainContainer}>
            <section className={styles.hero}>
                <img
                    src={image}
                    alt="test"
                    className={styles.parallax}
                    style={{
                        transform: `translateY(${offset * 0.5}px)`,
                    }}/>
            </section>
        </div>
    )
}
